import './Profile.scss';
import {useFetchProfileByUsername} from "../../features/profile/profileApi";
import LeftContent from "./LeftContent";
import RightContent from "./RightContent";
import ProfileMenu from "./ProfileMenu";
import React, {useEffect, useState} from "react";
import { useProfile } from "../../context/ProfileContext";
import EditIcon from "./EditIcon";

type Props = {
    username: string;
};

const ProfileContent = ({username}: Props) => {
    const {data:fetchedProfile} = useFetchProfileByUsername(username, `profile.${username}`)
    const { profile, setProfile, isLoggedUser } = useProfile();

    useEffect(() => {
        if (fetchedProfile) {
            setProfile(fetchedProfile);
        }
    }, [fetchedProfile, setProfile]);

    if (!profile) {
        return <></>
    }

    return (
        <section className="py-2 slide-left">
            <div className="container anim-delay-medium">
                <div className="row slide-top">
                    <div className="col-md-12">
                        <h2 className="text-white text-uppercase mb-1">
                            {`${profile.name}'s PROFILE`}
                        </h2>
                    </div>
                </div>
                <div className="row slide-left">
                    <div className="col-12">
                        <div className="card" id="sidebar">
                            <div className='row'>
                                <div className='col-12'>
                                    <div className='banner pop-in'>
                                        {profile.banner_enabled &&
                                            <img className='img-fluid' src={profile.banner} alt='banner'/>
                                        }

                                        {!profile.banner_enabled && isLoggedUser &&
                                            <div className='p-2'></div>
                                        }

                                        {isLoggedUser &&
                                            <ProfileMenu/>
                                        }
                                    </div>
                                </div>
                            </div>

                            <div className='row'>
                                <div className='col-md-3'>
                                    <LeftContent profile={profile}/>
                                </div>
                                <div className='col-md-9'>
                                    <RightContent profile={profile}/>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default ProfileContent;
